/**
 * 这里是Action Type 便于区分变量用大写
 */

export const OK = 0;

export const SHOW_DETAIL_DATA = 'SHOW_DETAIL_DATA';
export const SHOW_DETAIL_GRAY = 'SHOW_DETAIL_GRAY';
export const BANNER_LIST = 'BANNER_LIST';
export const CATEGOYR_LIST = 'CATEGOYR_LIST';
export const SHOW_LIST = 'SHOW_LIST';
export const ALL_CATEGOYR_LIST = 'ALL_CATEGOYR_LIST';
export const SHOW_CREATE_ORDER = 'SHOW_CREATE_ORDER';
export const SHOW_ORDER_lIST = 'SHOW_ORDER_lIST';
export const SHOW_ORDER_MENU_lIST = 'SHOW_ORDER_MENU_lIST';
export const SHOW_ORDER_BOOKING = 'SHOW_ORDER_BOOKING';
export const SHOW_CANCEL_ORDER = 'SHOW_CANCEL_ORDER';
export const ORDER_DETAIL = 'ORDER_DETAIL';
export const SELECT_CITY = 'SELECT_CITY';
export const GEO_LOCATION = 'GEO_LOCATION';
export const SEND_CODE = 'SEND_CODE';
export const VERIFY_CODE = 'VERIFY_CODE';
export const GET_LINK = 'GET_LINK';
export const CHECKLOGIN = 'CHECKLOGIN';
export const UNION_CODE = 'UNION_CODE';
export const UNION_CONFIG = 'UNION_CONFIG';
export const SEAT_TOKEN = 'SEAT_TOKEN';
export const GET_SEAT_INFO = 'GET_SEAT_INFO';
export const ORDER_CODE_DETAIL = 'ORDER_CODE_DETAIL';
export const USER_PHONE = 'USER_PHONE';
export const DELETE_ADRESS = 'DELETE_ADRESS';
export const DELETE_ADDRESS = 'DELETE_ADDRESS';
export const CREAT_ADDRESS = 'CREAT_ADDRESS';
export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';
export const LOGISTICS_DETAIL = 'LOGISTICS_DETAIL';
export const ADDRESS_LIST = 'ADDRESS_LIST';
export const ADDRESS_FEE = 'ADDRESS_FEE';
export const ADDRESS_RECENT = 'ADDRESS_RECENT';
export const GET_PHONE = 'GET_PHONE';
export const SAVE_HOME_STATE = 'SAVE_HOME_STATE';
export const CLEAR_HOME_STATE = 'CLEAR_HOME_STATE';
export const SAVE_LIST_STATE = 'SAVE_LIST_STATE';
export const CLEAR_LIST_STATE = 'CLEAR_LIST_STATE';
export const OUT_RECORD = 'OUT_RECORD';
export const GET_EXCHANGE_POINT = 'GET_EXCHANGE_POINT';
export const SAVE_ORDER_LIST_STATE = 'SAVE_ORDER_LIST_STATE';
export const CLEAR_ORDER_LIST_STATE = 'CLEAR_ORDER_LIST_STATE';
export const ADDRESS_List_SELF = 'ADDRESS_List_SELF';
export const NOTICE_CONTENT = 'NOTICE_CONTENT';
